import React from 'react';
import { twMerge } from 'tailwind-merge';

const UFInput = (props) => {
	const { label, required, optional, type = 'text', placeholder, value, disabled, errorMessage, onChange, maxLength, countryCode = '', name } = props;

	return (
		<div>
			<div className={twMerge('flex', required && 'items-start', optional && 'items-center')}>
				<label className='text-[var(--dark-gray)] font-semibold text-xxs'>{label}</label>
				{required && <span className='text-xxs text-[var(--pumping-spice)]'>*</span>}
				{optional && <span className='text-xxs text-[var(--tin)]'>(optional)</span>}
			</div>
			<div className='flex items-center gap-1.5'>
				{countryCode != '' && <span className='text-[var(--dark-gray)] font-semibold'>{countryCode}</span>}
				<input
					{...{ placeholder, type, value, disabled, maxLength, onChange, name }}
					className='!px-0 py-1.5 focus:outline-none !bg-white focus:!bg-gray-100 w-full disabled:text-gray-400 disabled:opacity-50 !border-b !border-solid !border-steam !mb-0.5 !rounded-none'
				/>
			</div>
			<p className='text-[var(--pumping-spice)] text-xxs font-medium h-[15px] text-red-500'>{errorMessage}</p>
		</div>
	);
};

export default UFInput;
